import React from 'react';
import { kebabCase } from 'lodash';
import { useField } from 'formik';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';
import { FieldLabel, FieldMessage } from './FieldChrome';
import useFieldMessage from './useFieldMessage';
import './disabledFields.css';

type FormikInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'value' | 'type' | 'size'
> & {
  name: string;
  id?: string;
  label?: React.ReactNode;
  value?: string | number | null;
  errorMessage?: string | null;
  // Marks the field invalid for an error that is not Formik's (e.g. a check
  // the caller runs itself); without it the red state follows Formik.
  invalid?: boolean;
  suffix?: React.ReactNode;
};

const FormikInput = ({
  name,
  id,
  label,
  value,
  onChange,
  onBlur,
  errorMessage,
  invalid,
  ...rest
}: FormikInputProps) => {
  const [field] = useField(name);
  const { hasError, message } = useFieldMessage(name, errorMessage);
  const inputId = id ?? kebabCase(name);

  return (
    <div className="h-8">
      {label && <FieldLabel htmlFor={inputId}>{label}</FieldLabel>}
      <Input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
        id={inputId}
        className="cwf-kit-field"
        name={name}
        value={value ?? field.value ?? ''}
        onChange={onChange ?? field.onChange}
        onBlur={event => {
          field.onBlur(event);
          onBlur?.(event);
        }}
        status={invalid ?? hasError ? 'error' : undefined}
      />
      <FieldMessage message={message} />
    </div>
  );
};

export default FormikInput;
